import * as React from 'react';
import { Table } from 'semantic-grab-ui/src';
import { Campaign } from 'types/ts/campaigns';
import { allowedOperators } from 'data/trident-campaigns';
import { getCountConditionVarName } from './util';
import _ from 'lodash';

interface Props {
  model: Campaign,
  currentNode: string,
  parentNode: string,
  parentKeyList: string[],
}

export default class CountConditionShow extends React.Component<Props> {
  constructor(props) {
    super(props);
  }

  getConditionLHSText = (lhs: string, countTargets: string[], scenarios: object[]) => {
    const texts = _.map(lhs.split('+'), c => {
      return getCountConditionVarName(countTargets[Number(c)-1], scenarios);
    });
    return texts.join(' + ');
  };

  render() {
    const spanStyle = {
      color: 'green',
      fontWeight: 700,
    };

    const { model, currentNode } = this.props;
    const conditions = _.get(model.nodes[currentNode], 'data.conditions', []);
    if (_.isEmpty(conditions)) {
      const data = _.get(model.nodes[currentNode], 'data', {});
      if (!_.isEmpty(data)) {
        conditions.push(data);
      }
    }

    const allowedOperatorsList = allowedOperators.reduce((result, o) => {
      result[o.value] = o.text;
      return result;
    }, {});

    const counters = _.get(this.props.model.nodes[this.props.parentNode], 'data.targets', []);
    const scenarios = _.get(this.props.model.nodes[this.props.parentKeyList[0]], 'data.scenarios', []);

    return (
      <div>
        <Table striped>
          <Table.Body>
            {conditions.map((condition) => {
              return (
                <Table.Row key={condition.lhs}>
                  <Table.Cell>
                    <p>If <span style={spanStyle}>{`${this.getConditionLHSText(condition.lhs, counters, scenarios)}`}</span> {`${allowedOperatorsList[condition.operator]} ${condition.rhs}`}</p>
                  </Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      </div>
    );
  }
}
